/**
 * Created by rak on 8/24/2018.
 */
'use strict';
angular.module('dashboard.tachoHistory', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('tachoHistoryWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.tachoHistory.ttachoHistoryTitle';
          },
          description: function () {
            return 'dashBoard.fleetManagement.tachoHistory.description';
          }
        },
        controller: 'tachoHistoryCtrl',
        templateUrl: 'components/dashboard/tachoHistory/tachoHistoryWidget.tpl.html',
        isSingleInstance: true,
        edit: {
          templateUrl: 'components/dashboard/tachoHistory/tachoHistoryWidgetEdit.tpl.html',
          reload: false,
          controller: 'tachoHistoryEditCtrl'
        }
      });

  }).service('tachoHistoryService', function (crudService, $filter) {


    var lastSelectedHisotoryRowData;
    this.getTachoeventHistoryList = function (dateFrom, isDataRefresh) {
      var requestParam = {
        dataRefresh: isDataRefresh,
        timeTo: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '23:59:59',
        timeFrom: $filter('date')(dateFrom, 'yyyy/MM/dd/') + '00:00:00',
        reportOptions: {}
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('driverdashboard/tachoeventhistory', '', param);
    };

    this.getLastSelectedHstoryRowData = function () {
      return lastSelectedHisotoryRowData;
    };

    this.setLastSelectedHstoryRowData = function (rowData) {
      lastSelectedHisotoryRowData = rowData;
    };
  }).controller('tachoHistoryCtrl', function ($scope, config, commonTrackService, errorHandlingService, $rootScope, tachoHistoryService, widgetSettingsCreatorService, $filter, vehicleListWidgetService, $timeout, stateManagerService) {

    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();
    $scope.isReady = false;
    $scope.datePicker = widgetSettingsCreatorService.createDatePickerInstance('dd.MM.yyyy');
    $scope.dateFilter = {
      date: new Date()
    };
    var rowSize = vehicleListWidgetService.getRowSize();


    $scope.customGridProperties = {
      eventDetailHistory: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] + 15 : 455,
        pageable: false,
        columns: []
      }
    };

    var eventDetailHistoryListSource =
    {
      datatype: 'array',
      datafields: [],
      localdata: [],
      sort: null
    };
    $scope.uuidForElement =  $scope.$id;

    var locadTachoEventHistoryList = function (date) {
      $scope.isReady = true;
      $scope.isNotAuthorized = false;
      $scope.isDataNotAvailable = false;
      return tachoHistoryService.getTachoeventHistoryList(date, true).then(function (eventDetailHistoryList) {
        if (eventDetailHistoryList.dataList) {
          $scope.isDataAvailable = true;
          if (!$scope.tachoEventListdataAdapter) {
            $scope.customGridProperties.eventDetailHistory.columns = commonTrackService.getColumnProperties(eventDetailHistoryList.gridSettings.overviewListGrids[0].columnProperties, eventDetailHistoryList.columnTranslation, { moduleName: 'tachoEventListGridSettings' });
            $scope.tachoEventListGridSettings = commonTrackService.getGridSettings('tachoEventListGridSettings', $scope.customGridProperties.eventDetailHistory, null);
            eventDetailHistoryListSource.localdata = eventDetailHistoryList.dataList;
            $scope.tachoEventListdataAdapter = new $.jqx.dataAdapter(eventDetailHistoryListSource);
            $scope.tachoEventListGridSettings.source = $scope.tachoEventListdataAdapter;
          }
          else {
            eventDetailHistoryListSource.localdata = eventDetailHistoryList.dataList;
            commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoEventListGridSettingsList');
          }
        }

        if (eventDetailHistoryList.dataList.length === 0) {
          eventDetailHistoryListSource.localdata = eventDetailHistoryList.dataList;
          commonTrackService.updateBoundData($scope.overviewGridPrefix + 'tachoEventListGridSettingsList');
        }

      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $rootScope.$broadcast('rest-error-event', response);
          $scope.isDataAvailable = false;
          $scope.isDataNotAvailable = true;
          $scope.isNotAuthorized = true;
        }
      }).finally(function () {
        $scope.isWidgetPreInitFinished = true;
        if ($scope.driverHistorydataLoadingFinished) {
          $timeout(function () {
            var rowindex = $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getselectedrowindex');
            if (rowindex !== null && rowindex > 0 && eventDetailHistoryListSource.localdata.length > 0) {
              $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('selectrow', rowindex);
            } else if (eventDetailHistoryListSource.localdata.length > 0) {
              $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('selectrow', 0);

            } else {
              $rootScope.$broadcast('tacho_event_history_row_select', { date: $scope.dateFilter.date, selectedRow: null });

              stateManagerService.updateValue('tachoHistoryWidget', 'tab_0_selectedRow', {}, true);

              $rootScope.$broadcast('tacho_detail_widget_event', {
                date: $filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'),
                selectedRow: null,
                eventType: 'tacho_event_history_data_empty'
              });

              $rootScope.$broadcast('dataStateUpdate', {
                widget: 'tachoHistoryWidget',
                activeTab: 0,
                dashboardName: 'dashboard.tachohistory',
                timespan: new Date().getTime()
              });

            }

            $rootScope.$broadcast('updateStampTimeEvent', { date: $scope.dateFilter.date });
          }, 500);
        }

        if (!$scope.driverHistorydataLoadingFinished) {
          $scope.driverHistorydataLoadingFinished = true;
        }
      });
    };


    $scope.tachoEventListGridSettingsSelectHandler = function (event) {
      if (event.args.row && $scope.driverHistorydataLoadingFinished) {
        var broadcastEventData = {
          selectedRow: event.args.row
        };

        $rootScope.$broadcast('tacho_detail_widget_event', {
          date: $filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'),
          selectedRow: _formaDataForSvg(event.args.row),
          eventType: 'tacho_event_history_table_row_select'
        });
        broadcastEventData.date = $scope.dateFilter.date;

        $rootScope.$broadcast('tacho_event_history_row_select', broadcastEventData);

        stateManagerService.updateValue('tachoHistoryWidget', 'date', $scope.dateFilter.date, true);
        stateManagerService.updateValue('tachoHistoryWidget', 'deviceID', broadcastEventData.selectedRow.deviceID, true);
        stateManagerService.updateValue('tachoHistoryWidget', 'rowData', broadcastEventData, false); // outDated ?
        stateManagerService.updateValue('tachoHistoryWidget', 'tab_0_selectedRow', broadcastEventData.selectedRow, true);



        $rootScope.$broadcast('dataStateUpdate', {
          widget: 'tachoHistoryWidget',
          activeTab: 0,
          dashboardName: 'dashboard.tachohistory',
          timespan: new Date().getTime()
        });

        tachoHistoryService.setLastSelectedHstoryRowData(broadcastEventData);
      }

    };

    function _formaDataForSvg(rowdata) {
      rowdata.worktimebetweenpause = '00h 00m';
      rowdata.drivetimebetweenpause = '00h 00m';
      return rowdata;
    }

    $scope.dateFilterPrevDay = function () {
      $scope.dateFilter.date = new Date($scope.dateFilter.date.getTime() - (24 * 60 * 60 * 1000));
      $('#dateFilterInput').val($filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'));
    };
    $scope.dateFilterNextDay = function () {
      $scope.dateFilter.date = new Date($scope.dateFilter.date.getTime() + (24 * 60 * 60 * 1000));
      $('#dateFilterInput').val($filter('date')($scope.dateFilter.date, 'dd.MM.yyyy'));
    };
    $scope.$watch('dateFilter.date', function (value) {
      if (value) {

        locadTachoEventHistoryList(value, true);

        stateManagerService.updateValue('tachoHistoryWidget', 'date', $scope.dateFilter.date, true);

        $rootScope.$broadcast('tacho_detail_widget_event', {
          date: $filter('date')(value, 'dd.MM.yyyy'),
          eventType: 'date_change'
        });
      }
    });

    locadTachoEventHistoryList($scope.dateFilter.date);
    var vehicleMapCurrentContextDataRegEv = $scope.$on('vehicleMap_req_current_context', function () {
      var rowindex = $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getselectedrowindex');
      var selectedRow = {};
      if (rowindex) {
        selectedRow = $('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getrowdata', rowindex);

      }
      $rootScope.$broadcast('vehicleMap_res_current_context', {
        dashboardName: 'dashboard.tachohistory',
        isDataFromTab: true,
        tabNumber: 0,
        currentWidgetContextData: {
          selectedRow: selectedRow,
          selectedOrderRow: {},
          dashboardName: 'dashboard.tachohistory',
          isDataFromTab: true
        },
        dataLoadingFinished: $scope.dataLoadingFinished,
        isDataAvailable: $scope.isDataAvailable
      });
    });
    // stateManagerService
    // Used when unkown dependant (child) widget requests data.
    // Since this is a global request for data, widget needs to check if the,
    // requested fields is anything it can provide before updating.
    // Will call the dataStateUpdate event if it updates data.
    var updateRequest = $scope.$on('reqDataUpdate', function () {
      var selectedRowData = {};
      var selectIndex = -1;

      selectIndex = window.$('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getselectedrowindex');
      if (selectIndex > -1) {
        selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'tachoEventListGridSettingsList').jqxGrid('getrowdata', selectIndex);
      }
      // push the changes to stateManagerService
      stateManagerService.updateValue('tachoHistoryWidget', 'tab_0_selectedRow', selectedRowData, true);

      $rootScope.$broadcast('resDataUpdate',
        {
          widget: 'tachoHistoryWidget',
          activeTab: 0,
          dashboardName: 'dashboard.tachohistory',
          timespan: new Date().getTime()
        });
    });
    $scope.$on('$destroy', function () {
      vehicleMapCurrentContextDataRegEv();
      updateRequest();
    });
  }).controller('tachoHistoryEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {

    $scope.noOfGridRows = config.noOfGridRows;
    var source = [
      '5', '10', '15', '25', '50', '75', '100'
    ];

    // init DropDownList's settings object.
    $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,

      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
      source: source
    };

    $scope.noOfGridOnChange = function (event) {
      config.noOfGridRows = event.args.item.value;
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/tachoHistory/tachoHistoryWidget.js